import React, { useEffect, useState } from "react";
import instance from "../../Utils/api.js";
import "../styles/pages/profile.scss";
import { useNavigate } from 'react-router-dom';
import SearchIcon from "@mui/icons-material/Search";
import { Table, TableHead, TableBody, TableRow, TableCell, Typography, Pagination, TextField, InputAdornment } from '@mui/material';

const CartOrders = () => {
  const navigate = useNavigate();
  const [item, setItem] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState('');

  const fetchOrderDetails = async (page = 1, search) => {
    try {
      const response = await instance.get("/Order/Orders", {
        params: {
          search,
          page,
          limit: rowsPerPage,
        },
      });

      setItem(response.data.data);
      setTotalPages(response?.data?.totalPages);
      setCurrentPage(response?.data?.currentPage);
      setTotalCount(response?.data?.total);
    } catch (err) {
      console.log(err);
    }
  };


  // Pagination change handler
  const handleChange = (event, value) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    fetchOrderDetails(currentPage, search);
  }, [currentPage, search]);

  // const fetchOrderAlteration = async (id) => {
  //   try {
  //     const response = await instance.patch("/Order/RaiseOrderAlteration", {
  //       Suborder_id: id,
  //     });

  //     if (response.status === 200) {
  //       toast.success(response.data.message);
  //       fetchOrderDetails();
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  return (
    <React.Fragment>


      <div className="mycart-title">
        <Typography variant='h4'>My Orders</Typography>
        <TextField
          placeholder={"Search Orders"}
          type="search"
          variant="outlined"
          // style={{ marginBottom: 20 }}
          value={search}
          onChange={(e) => { setSearch(e.target.value) }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          size='small'
        />
      </div>

      {/* {item.length > 0
          ? item.map((order, index) => (
            <div key={index} className="mycart-details" onClick={() =>
              navigate(
                `/profile/orders-details/${order.order_id}`)
            }>
              <div className="product-image">
                <Image
                  src={order?.design?.picture[0]}
                  alt="orderimage"
                  width={150}
                  height={160}
                />
              </div>
              <div className="product-description">
                <div className="main-product-content">
                  <div className="product-content">
                    <div className="my-orders">
                      <Typography>
                        <span>Order Id</span> : {order?.sub_order_id}
                      </Typography>
                      <Typography>
                        <span>Product</span> : {order?.design?.name}
                      </Typography>
                      <Typography>
                        <span>Size</span> : {order?.size}
                      </Typography>
                      <Typography>
                        <span>Quantity</span> : {order?.quantity}
                      </Typography>
                      <Typography>
                        <span>Status</span> : {order?.status}
                      </Typography>
                      <Typography>
                        <span>Description</span>:{order?.design?.description}
                      </Typography>
                      <div>
                        {order?.final_image ?
                          <Typography>
                            <span>Final Image</span>
                            <div className="final-image">
                              {order?.final_image?.length > 0 ? (
                                <GetLink
                                  href={order.final_image}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {order.final_image}
                                </GetLink>
                              ) : (
                                "---"
                              )}
                            </div>
                          </Typography>
                          : null}
                      </div>
                      <Typography>
                        <span>Documents</span>
                      </Typography>
                      <div className="alteration-btn-container">
                        {order?.documents?.length > 0 ? (
                          <GetLink
                            href={order.documents}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {order.documents}
                          </GetLink>
                        ) : (
                          "---"
                        )}
                        {order?.status === "Completed" && new Date() - new Date(order.updatedAt) <= 3 * 24 * 60 * 60 * 1000 ? (
                          <Button
                            onClick={() => fetchOrderAlteration(order._id)}
                            className="btn-alteration"
                          >
                            Raise Alteration
                          </Button>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
          : "No Item Found"} */}

      <div className="employee-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Date</TableCell>
              <TableCell align="center">Order ID</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {item.length > 0 ? (
              item.map((order, index) => (
                <TableRow
                  key={order._id}
                  hover
                  sx={{ cursor: "pointer" }}
                  onClick={() => navigate(`/profile/orders-details/${order._id}`)}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{new Date(order.createdAt).toLocaleDateString("en-GB")}</TableCell>
                  <TableCell>{order.order_id}</TableCell>
                  <TableCell>
                    <span
                      style={{
                        backgroundColor: getStatusBackgroundColor(order.status),
                        color: getStatusTextColor(order.status),
                        padding: "5px 10px",
                        borderRadius: "5px",
                        textAlign: "center",
                        display: "inline-block",
                      }}
                    >
                      {order?.status === "New Order received" ? "Order Placed" : order?.status}
                    </span>
                  </TableCell>
                  <TableCell>₹{order?.total_amount ? Number(order.total_amount).toFixed(2) : "0.00"}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  <Typography>No orders available</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {currentPage &&
          <div className="pagination_table">
            <div>
              Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
              {Math.min(currentPage * rowsPerPage, totalCount)} of {totalCount} results
            </div>

            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handleChange}
              color="primary"
            />
          </div>
        }

      </div>


    </React.Fragment>
  );
};

// Function for status background color
const getStatusBackgroundColor = (status) => {
  const colors = {
    "Order Placed": "#E0F7FA",           // light cyan
    "Designer Assigned": "#E8F5E9",            // light green
    "In Payment": "#E3F2FD",                   // light blue
    "Estimate Sent": "#FFF3E0",                // light orange
    "Estimate approved by Customer": "#EDE7F6",// light indigo
    "Order In Progress": "#E0F2F1",            // light teal
    "Order Ready": "#FCE4EC",                  // light pink
    "Delivery Scheduled": "#CFD8DC",           // blue-grey
    "Order Delivered": "#F1F8E9",              // light lime
    "Alteration request raised": "#FFF8E1",    // light yellow
    "Order Canceled": "#FFEBEE",               // light red
  };
  return colors[status] || "#ECEFF1"; // Default light grey
};


// Function for status text color
const getStatusTextColor = (status) => {
  const colors = {
    "Order Placed": "#00796B",           // teal
    "Designer Assigned": "#2E7D32",            // green
    "In Payment": "#1565C0",                   // blue
    "Estimate Sent": "#EF6C00",                // deep orange
    "Estimate approved by Customer": "#5E35B1",// indigo
    "Order In Progress": "#00897B",            // teal
    "Order Ready": "#C2185B",                  // pink
    "Delivery Scheduled": "#263238",           // blue-grey (dark)
    "Order Delivered": "#689F38",              // lime green
    "Alteration request raised": "#F9A825",    // yellow
    "Order Canceled": "#D32F2F",               // red
  };
  return colors[status] || "#37474F"; // Default dark grey
};


export default CartOrders;
